import { Theme } from '@trimble/page-header';

// Centralized theme color constants
export const THEME_COLORS = {
  light: {
    // Web3D viewer backgrounds
    backgroundTopColor: '#f1f1f6', // gray-light
    backgroundBottomColor: '#e0e1e9', // gray-0
    textColor: '#252a2e',
    darkModeMaterials: false,

    // DOM/CSS colors
    domBackgroundColor: '#f1f1f6',
    domTextColor: '#252a2e',
  },
  dark: {
    // Web3D viewer backgrounds
    backgroundTopColor: '#353a40', // gray-9,
    backgroundBottomColor: '#171c1e', // gray-10,
    textColor: '#ffffff',
    darkModeMaterials: true,

    // DOM/CSS colors
    domBackgroundColor: '#252a2e',
    domTextColor: '#ffffff',
  },
} as const;

// Utility functions
export function getThemeColors(theme: Theme): (typeof THEME_COLORS)[Theme] {
  return THEME_COLORS[theme];
}

export function getWeb3dSettingsForTheme(theme: Theme): {
  backgroundTopColor: string;
  backgroundBottomColor: string;
  textColor: string;
  darkModeMaterials: boolean;
} {
  const colors = getThemeColors(theme);
  return {
    backgroundTopColor: colors.backgroundTopColor,
    backgroundBottomColor: colors.backgroundBottomColor,
    textColor: colors.textColor,
    darkModeMaterials: colors.darkModeMaterials,
  };
}

export function detectSystemTheme(): Theme {
  return window.matchMedia('(prefers-color-scheme: dark)')?.matches
    ? 'dark'
    : 'light';
}
